/* eslint-disable import/no-cycle */
import * as actions from 'store/actions';
import { AppThunk, Server } from 'types';
import _get from 'lodash/get';
import { fetchUserProfile } from './user';

export const getUserSession = (): AppThunk => (dispatch) => {
  const sessionToken = localStorage.getItem('sessionToken');
  dispatch(actions.sessionTokenSuccess(sessionToken));
};

export const authCheckLogin = (): AppThunk<Promise<void>> => async (dispatch) => {
  try {
    const sessionToken = localStorage.getItem('sessionToken');
    const storedSignedInAs = localStorage.getItem('signedInAs');
    const storedPostingAs = localStorage.getItem('postingAs');
    const storedSelectedServer = localStorage.getItem('selectedServer');

    dispatch(getUserSession());

    let signedInAsUserId: string | undefined;
    let postingAsUserId: string | undefined;

    if (storedSignedInAs) signedInAsUserId = _get(JSON.parse(storedSignedInAs || '{}'), 'UserId', '') as string;
    if (storedPostingAs) postingAsUserId = _get(JSON.parse(storedPostingAs || '{}'), 'UserId', '') as string;

    if (signedInAsUserId && postingAsUserId) {
      dispatch(actions.signInSuccess(signedInAsUserId, false, sessionToken));
      if (sessionToken) {
        await dispatch(fetchUserProfile(false, signedInAsUserId, 'signedInAs', signedInAsUserId === postingAsUserId));
        if (signedInAsUserId !== postingAsUserId) {
          await dispatch(fetchUserProfile(true, postingAsUserId, 'postingAs'));
        }
        if (storedSelectedServer) {
          const selectedServer = JSON.parse(storedSelectedServer || '{}') as Server;
          dispatch(actions.setSelectedServerSuccess(selectedServer));
        }
      }
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
};

export default {};
